module.exports = __webpack_public_path__ + "img/details_3.81d51a55.jpg";